import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/Api/axiosV2Config';

export interface InternalUser {
  id: string;
  civility: string | null;
  firstname: string | null;
  lastname: string | null;
  email: string;
  phone: string | null;
  avatar: string | null;
  position: string | null;
  roleType: 'COMMERCIAL' | 'SUPERVISOR' | 'SUPER_ADMIN';
  permissions: string[];
  isActive: number;
  createdAt: string;
  updatedAt: string;
}

export interface InternalUsersResponse {
  users: InternalUser[];
  total: number;
}

export function useInternalUsers(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['internal-users'],
    queryFn: async (): Promise<InternalUser[]> => {
      const { data } = await axiosInstance.get<InternalUsersResponse>(
        '/internal-users-v2',
        {
          params: { limit: 1000, isActive: true },
        }
      );
      return data.users;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    // enabled par défaut : true (rétrocompatible). Permet de ne pas déclencher
    // l'appel (droit internal_user.list, INTERNAL only) pour un user externe.
    enabled: options?.enabled ?? true,
  });
}

export function useInternalUser(userId: string | undefined) {
  return useQuery({
    queryKey: ['internal-user', userId],
    queryFn: async (): Promise<InternalUser> => {
      const { data } = await axiosInstance.get<InternalUser>(
        `/internal-users-v2/${userId}`
      );
      return data;
    },
    enabled: !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
